export const COMMENT_STATUS = {
  PENDING: 'Pending',
  REPLIED: 'Replied',
  DISMISSED: 'Dismissed',
  AUTO_DISMISSED: 'Automatically Dismissed',
  SENDING: 'Sending',
  DISMISSING: 'Dismissing',
  OPENING: 'Opening',
}
